@if ({count: mostRecentCount$ | async}; as state) {
  @if (state.count) {
    <div class="alerts-count">
      {{ state.count > 50 ? '50+' : state.count }}
    </div>
  }
}
